import {
  AlignSelf,
  Body1,
  Body3,
  Box,
  Color,
  Display,
  Display3,
  FlexDirection,
  RadiusScale,
  Space,
  withCitrusTheme,
} from '@gousto-internal/citrus-react';

const BADGE_RADIUS = 2 as RadiusScale;

const UppercaseHeading = withCitrusTheme(Display3, () => ({
  textTransform: 'uppercase',
}));

export function PricingHero() {
  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
      <Box
        bg={Color.Success_900}
        display={Display.InlineFlex}
        alignSelf={AlignSelf.Start}
        borderRadius={BADGE_RADIUS}
        paddingV={0.5}
        paddingH={2}
      >
        <Body3 color={Color.White}>Now with new lower prices</Body3>
      </Box>
      <Space size={2} />
      <UppercaseHeading color={Color.ColdGrey_800} size={11}>
        Ireland&rsquo;s best value recipe box
      </UppercaseHeading>
      <Space size={2} />
      <Body1 color={Color.ColdGrey_800}>
        Enjoy restaurant-quality meals from just €2 a portion on your first box.*
      </Body1>
    </Box>
  );
}
